import React from 'react';
import { Dimensions, ScrollView } from 'react-native';
import Modal from 'react-native-modalbox';

import { Container } from './styles';

const { height } = Dimensions.get('window');

interface BottomSheetProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  component: JSX.Element | null;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  setOpen,
  component
}) => {
  return (
    <Modal
      isOpen={isOpen}
      position="bottom"
      onClosed={() => setOpen(false)}
      swipeArea={20}
      style={{
        height: height * 0.9,
        borderTopRightRadius: 20,
        borderTopLeftRadius: 20
      }}
    >
      <Container>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: 'flex-end',
            paddingRight: 16,
            paddingLeft: 16,
            paddingBottom: 0
          }}
        >
          {component}
        </ScrollView>
      </Container>
    </Modal>
  );
};

export default BottomSheet;
